declare var require: any;
/*
export const environment = {
  production: false,
  urlBackEndCallBackAssinatura: 'http://localhost:8080/assinatura/call-back',
  cpfAssinateTeste: '40391647334', //'05064243324',
  VERSION: require('../../package.json').version
};
*/

//TESTE
/*
export const environment = {
  production: true,
  urlBackEndCallBackAssinatura: 'https://agora-tst.tce.ce.gov.br:8443/assinatura/call-back',
  cpfAssinateTeste: '40391647334', //'05064243324',
  VERSION: require('../../package.json').version
};
*/

// HOMOLOGACAO
/*
export const environment = {
  production: true,
  // urlBackEndCallBackAssinatura: 'https://agora-hom.tce.ce.gov.br:10443/agora-api/ws/assinatura/call-back',
  urlBackEndCallBackAssinatura: 'https://localhost:10443/agora-api/ws/assinatura/call-back',
  cpfAssinateTeste: null,
  VERSION: require('../../package.json').version
};
*/

//PRODUÇÃO
export const environment = {
  production: true,
  urlBackEndCallBackAssinatura: 'https://agora.tce.ce.gov.br:9443/agora-api/ws/assinatura/call-back',
  cpfAssinateTeste: null,
  googleAnalyticsTrackingId: 'G-85KLRT5G6V',
  VERSION: require('../../package.json').version
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts